import {createI18n} from 'vue-i18n'
import isUndefined from 'lodash/isUndefined';
import merge from 'lodash/merge'

// Locale messages are static imports. Sequential `await import()` calls here
// held app.mount for two extra round trips on every cold page load. Each file
// is imported once even when several locales point at it.


import * as __vfLocale0 from '~/core/locales/en-gb/index.ts'
import * as __vfLocale1 from '~/../checkout-app/lib/locales/en-gb/index.mjs'

function loadLocaleMessages(options) {
  const messages = {}
  let result = {}

  
    if(isUndefined(messages['en-gb'])) {
      messages['en-gb'] = {}
    }
    
      result = __vfLocale0
      
    messages['en-gb'] = merge({}, messages['en-gb'], result)
    
    
      result = __vfLocale1
      
    messages['en-gb'] = merge({}, messages['en-gb'], result)
    
    

  
    if(isUndefined(messages['ru-ru'])) {
      messages['ru-ru'] = {}
    }
    
      result = __vfLocale1
      
    messages['ru-ru'] = merge({}, messages['ru-ru'], result)
    
    

  

  return messages
}


export default async (ctx, inject) => {
  const messages = loadLocaleMessages()

  const i18n =  createI18n({
    locale: ctx.$store.getters['common/language/locale'],
    messages
  })
  ctx.app.use(i18n)

  return i18n
}